import React from "react";
import {Box} from "@mui/system";
import {TextField, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

const GroupName = ({error, value, setGroupName}) => {
	const { t } = useTranslation();
	return (
		<Box sx={{py: 1}}>
			<Typography variant="h6" sx={{pb: 1}}>
				{t("Give your group a name")}
			</Typography>
			<TextField
				value={value}
				autoComplete="off"
				error={error}
				autoFocus
				id="name"
				placeholder={t("Group name")}
				type="text"
				fullWidth
				variant="outlined"
				required
				helperText={error && t("Group name is required")}
				onChange={(e) => setGroupName(e.target.value)}
				sx={{background: "#fff"}}
				slotProps={{
					input: {sx: {background: "#fff"}}
				}}

			/>
		</Box>
	);
};
export default GroupName;
